import { AutoPaymentTab } from 'billing/components/CreditCardDialog/AutoPaymentTab/AutoPaymentTab';
import { BindCard } from 'billing/components/CreditCardDialog/BindCard/BindCard';
import { getCreditCardActions } from 'billing/modules/CreditCardModule/CreditCardModule';
import React, { useState } from 'react';
import { ReduxHooks } from 'utils/hooks/ReduxHooks';
import { useBoundActions } from 'utils/hooks/useBoundActions';

import {
    BoundCurrentUserSelectors,
    CurrentUserSelectors,
} from 'reactApp/modules/CurrentUserModule';
import {
    BoundProjectActions,
    BoundProjectSelectors,
} from 'reactApp/modules/ProjectModule';
import Dialog from 'reactComponents/dialog/Dialog';
import {
    DialogAsMethodRederer,
    DialogAsMethodRedererProps,
} from 'reactComponents/DialogAsMethodRederer/DialogAsMethodRederer';
import { PhoneVerificationDialog } from 'reactComponents/PhoneVerificationDialog/PhoneVerificationDialog';
import { Tabs } from 'reactComponents/Tabs/Tabs';

import styles from './CreditCardDialog.css';

type OwnProps = {
    onBind?(): void;
};
type Props = OwnProps & DialogAsMethodRedererProps;
function _CreditCardDialog({ isOpened, onClose, onBind }: Props) {
    const [activeIndex, setActiveIndex] = useState(0);

    const pid = ReduxHooks.useSelector(CurrentUserSelectors.getPid);
    const loadCard = useBoundActions(getCreditCardActions(pid).loadData);

    return (
        <Dialog open={isOpened} onCancel={onClose} header="Настройка оплаты">
            <Tabs
                onTabChange={(e, { activeIndex }) => {
                    setActiveIndex(activeIndex);
                }}
                activeIndex={activeIndex}
                panes={[
                    {
                        menuItem: 'Привязка карты',
                        render() {
                            return null; // контент находится ниже. так сделано чтобы dmrFrame не удалялся при переходе на вкладку автопополнение
                        },
                    },
                    {
                        menuItem: 'Автопополнение',
                        render() {
                            return null;
                        },
                    },
                ]}
                className={styles.tab}
            />
            <TabWrapper>
                <BindCard
                    isShown={activeIndex === 0}
                    onClose={onClose}
                    onSuccess={onSuccess}
                />
                <AutoPaymentTab onClose={onClose} isShown={activeIndex === 1} />
            </TabWrapper>
        </Dialog>
    );

    function onSuccess() {
        const delayListInSeconds = [5, 10, 20, 40, 80];
        const loadCardConsumer = async () => {
            const card = await loadCard();

            if (card) {
                setActiveIndex(1);
                onBind && onBind();
                return;
            }
            const delayTime = delayListInSeconds.shift();

            if (delayTime) {
                setTimeout(loadCardConsumer, delayTime * 1000);
            }
        };

        loadCardConsumer();
    }
}

export const CreditCardDialog = Object.assign(
    DialogAsMethodRederer.makeDialogRenderer(_CreditCardDialog),
    {
        async renderWithVerification() {
            if (!BoundCurrentUserSelectors.getIsPhoneVerified()) {
                PhoneVerificationDialog.render({
                    async onConfirmed() {
                        if (BoundProjectSelectors.getIsUnverifiedProject()) {
                            await BoundProjectActions.fraudCheck();
                        }

                        CreditCardDialog.render();
                    },
                    dialogDescription:
                        'Для привязки карты необходимо подтвердить номер телефона',
                });
                return;
            }

            if (BoundProjectSelectors.getIsUnverifiedProject()) {
                await BoundProjectActions.fraudCheck();
            }

            CreditCardDialog.render();
        },
    },
);

function TabWrapper({ children }) {
    return <div className={styles.tabWrapper}>{children}</div>;
}
